export enum ActionTypes {
    ADD_BLOCK_AREA = "ADD_BLOCK_AREA",
    ADD_CHILDREN_TO_BLOCK_AREA = "ADD_CHILDREN_TO_BLOCK_AREA",
    ADD_WINDOW_TO_BLOCK_AREA = "ADD_WINDOW_TO_BLOCK_AREA",
    REMOVE_WINDOW_FROM_BLOCK_AREA = "REMOVE_WINDOW_FROM_BLOCK_AREA",
    UPDATE_CHILDREN_TO_BLOCK_AREA = "UPDATE_CHILDREN_TO_BLOCK_AREA",
    REMOVE_BLOCK = "REMOVE_BLOCK",
    CLEAR = "CLEAR",
    ELEMENT_CHANGED = "ELEMENT_CHANGED",
}
